export const _state = {
    isShow: false,
    message: '',
};

export function snackMessageReducer(state = _state, action) {

    switch (action.type) {

        case 'SNACK_MESSAGE_SHOW':
            return {
                ...state,
                isShow: true,
                message: action.payload.message
            };

        case 'SNACK_MESSAGE_HIDE':
            return {
                ...state,
                isShow: false,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/snack_message.js